<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <fa-icon [icon]="['fas', 'keyboard']"></fa-icon>
    <h2 ngpDialogTitle>
      {{ "command-palette.title.go-to-page" | translate }}
    </h2>
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <div class="palette" (keydown)="onKeydown($event)">
      <sui-input
        #searchInput
        type="text"
        autocomplete="off"
        [placeholder]="'command-palette.placeholder.type-a-page-name' | translate"
        [ngModel]="query()"
        (ngModelChange)="onQuery($event)"
      ></sui-input>

      <p class="palette__hint">
        {{
          "command-palette.hint.arrows-move-enter-opens-esc-closes"
            | translate
        }}
      </p>

      <div class="palette__box">
        <ul class="palette__list" role="listbox" [id]="listId">
          @for (group of groups(); track group.titleKey) {
            <li class="palette__group" role="presentation">
              {{ group.titleKey | translate }}
            </li>
            @for (entry of group.rows; track $index) {
              <li>
                <button
                  #option
                  type="button"
                  role="option"
                  class="palette__option"
                  [class.palette__option--active]="
                    group.offset + $index === activeIndex()
                  "
                  [id]="optionId(group.offset + $index)"
                  [attr.aria-selected]="group.offset + $index === activeIndex()"
                  (mouseenter)="hover(group.offset + $index)"
                  (click)="go(entry)"
                >
                  <span class="palette__icon" aria-hidden="true">
                    @if (entry.icon) {
                      <fa-icon [icon]="entry.icon"></fa-icon>
                    }
                  </span>
                  <span class="palette__path">
                    <span class="palette__crumb">{{ entry.area }}</span>
                    <fa-icon
                      class="palette__arrow"
                      [icon]="['fas', 'arrow-right']"
                      aria-hidden="true"
                    ></fa-icon>
                    @if (entry.section) {
                      <span class="palette__crumb">{{ entry.section }}</span>
                      <fa-icon
                        class="palette__arrow"
                        [icon]="['fas', 'arrow-right']"
                        aria-hidden="true"
                      ></fa-icon>
                    }
                    <span
                      class="palette__crumb palette__crumb--item"
                      [innerHTML]="entry.item | highlight: query()"
                    ></span>
                  </span>
                </button>
              </li>
            } @empty {
              <li class="palette__empty" role="presentation">
                {{ "command-palette.message.no-matching-pages" | translate }}
              </li>
            }
          }
        </ul>
      </div>
    </div>
  </ng-template>
</sui-dialog-simple>
